<div class="z-contenedor">
  <div *ngIf="imgUrl">
    <img loading="lazy" draggable="false" [src]="imgUrl" alt="Banner de Zenit Seguros"
      style="width: 100%; margin-top: 20px; margin-bottom: 20px" height="100%" width="100%" />
  </div>
  <div *ngIf="!imgUrl" class="mt-3 mb-4">
    <app-header></app-header>
  </div>
  <router-outlet></router-outlet>
  <app-footer [tipo]="'simple'"></app-footer>
</div>